import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import "./CategoryContent.css"; // Custom CSS
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";

const CategoryContent = () => {
    const { channel_Name } = useParams();
    console.log("channel_Name", channel_Name)
    const [category, setCategory] = useState({});
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 9;

    useEffect(() => {
        const fetchCategoryContent = async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(`${API}/api/lesson/channel/${channel_Name}`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                console.log("data", data)
                setCategory(data?.data[0]?.category || {});
                setContents(data?.data);
                setTotalPages(Math.ceil(data?.data?.length / itemsPerPage));
                setLoading(false);
            } catch (error) {
                console.error("Error fetching channel details:", error);
                setLoading(false);
            }
        };

        fetchCategoryContent();
    }, [channel_Name, itemsPerPage]);

    const getPaginatedData = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return contents?.slice(startIndex, startIndex + itemsPerPage);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };
    const generateSlug = (title, id) => {
        return `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;
    };
    return (
        <>
            <Helmet>
                <title>
                    {category?.name
                        ? `${category?.name} - OTT Channel | Watch Now`
                        : "Explore Channels - OTT Channel"}
                </title>
                <meta
                    name="description"
                    content={`Explore the best ${category?.name?.toLowerCase() || "Channels"} on our OTT Channel, featuring exclusive movies, TV shows, and more.`}
                />
                <meta
                    name="keywords"
                    content={`${category?.name || "Channels"}, OTT Channel, Streaming, Movies, TV Shows, Exclusive Content`}
                />
            </Helmet>



            <NavBar categoryLogo={category?.CategoryLogo?.url} categoryId={channel_Name} />

            <div className="px-3 px-md-5 px-lg-7">
                {loading && (
                    <div className="loading-screen d-flex justify-content-center align-items-center vh-100">
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3 text-white">Loading Channels content...</p>
                        </div>
                    </div>
                )}

                {!loading && (
                    <>
                        {contents?.length > 0 && category?.banner?.url && (
                            <div className="category-banner mb-4">
                                <img
                                    src={category.banner.url}
                                    alt={category.name || "Channel"}
                                    className="img-fluid w-100 rounded"
                                />
                            </div>
                        )}

                        <div className="row">
                            {contents?.length > 0 ? (
                                getPaginatedData()?.map((content) => (
                                    <div
                                        className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                                        key={content._id}
                                    >
                                        <Link to={`/view/${generateSlug(content?.title, content._id)}`} className="content-card-link">
                                            <div className="card shadow-sm content-card">
                                                <div className="image-wrapper">
                                                    <img
                                                        src={content.thumbnail}
                                                        alt={content.title}
                                                        className="card-img-top lazy-img"
                                                        style={{ objectFit: "cover", height: "200px" }}
                                                    />
                                                </div>
                                                <div className="card-body">
                                                    <h5 className="card-title text-center">
                                                        {content.title}
                                                    </h5>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                // Empty state design
                                <div className="col-12 d-flex align-items-center justify-content-center" style={{ minHeight: "300px" }}>
                                    <div className="text-center">
                                        {/* <img
                                            src="/path/to/empty-state-image.svg" // Add an illustrative image for empty state
                                            alt="No Content"
                                            className="img-fluid mb-3"
                                            style={{ maxWidth: "150px" }}
                                        /> */}
                                        <h4 className="text-muted">No videos uploaded</h4>
                                        <p className="text-muted">
                                            Related to this channel, please check back later.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>



                        {contents?.length > itemsPerPage && (
                            <nav>
                                <ul className="pagination justify-content-center">
                                    <li
                                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <li
                                            className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                            key={index}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(index + 1)}
                                            >
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default CategoryContent;
